import styled from 'styled-components';

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
  width: 100%;
`;

const BaseImage = styled.img`
  height: auto;
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(0, 102, 255, 0.1);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 102, 255, 0.15);
  }
`;

export const HeroImg = styled(BaseImage)`
  max-width: 50%;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    box-shadow: inset 0 0 0 1px rgba(0, 102, 255, 0.2);
    pointer-events: none;
  }
`;

export const FlowImg = styled(BaseImage)`
  max-width: 70%;
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
`;

export const ExampleImg = styled(BaseImage)`
  max-width: 60%;
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
`; 